module.exports = __webpack_public_path__ + "img/paci_en_8.5d440d28.png";